import { httpClient } from "@coworker/http-client";
import { useQuery } from "@tanstack/react-query";
import type { LaunchMediaPreviewImage } from "../types/launch";

const mediaImagesQueryKey = (mediaId: string | undefined) =>
  ["launch-media", "medias", mediaId, "images"] as const;

export function useMediaImages(mediaId: string | undefined) {
  return useQuery({
    queryKey: mediaImagesQueryKey(mediaId),
    queryFn: async () => {
      const response = await httpClient.mediaMgmt.get<{
        images: LaunchMediaPreviewImage[];
      }>(`/medias/${encodeURIComponent(mediaId!)}/images`);
      return response.images ?? [];
    },
    enabled: !!mediaId,
  });
}
